import React, { useRef } from 'react';
import { Button } from '@mui/material';
import { parseCSV } from '../utils/csvParser';
import { v4 as uuidv4 } from 'uuid';

function CSVUploader({ onUpload, buttonProps = {} }) {
  const fileInputRef = useRef(null);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const data = await parseCSV(file);
      onUpload({
        id: uuidv4(),
        fileName: file.name,
        data: data
      });
    } catch (error) {
      console.error('Error parsing CSV:', error);
      // You might want to show an error message to the user here
    }

    // Reset the file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <>
      <input
        type="file"
        accept=".csv"
        onChange={handleFileChange}
        style={{ display: 'none' }}
        ref={fileInputRef}
      />
      <Button
        variant="outlined"
        onClick={() => fileInputRef.current?.click()}
        {...buttonProps}
      >
        CSV
      </Button>
    </>
  );
}

export default CSVUploader; 